import { render } from "./CustomOssUploader.vue?vue&type=template&id=213fa138"
import script from "./CustomOssUploader.vue?vue&type=script&lang=js"
export * from "./CustomOssUploader.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__